import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import {SearchCriteria} from "../../_models";

@Directive({
  selector: '[ts-wrapper]'
})
export class TableSortWrapper {
  @Input('ts-wrapper') searchCriteria: SearchCriteria;
  @Output() sortChange = new EventEmitter();

  constructor(private el: ElementRef) {
    this.sortChange.subscribe(x => {

    });
  }

  changeSorting(column: string, direction: string){
    this.searchCriteria.sortColumn = column;
    this.searchCriteria.sortDirection = direction;
    this.sortChange.emit({column, direction});
  }
}
